import { render, staticRenderFns } from "./CAM0610.vue?vue&type=template&id=f589f2da&"
import script from "./CAM0610.vue?vue&type=script&lang=js&"
export * from "./CAM0610.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VBtn,VDatePicker})
